import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[long-press]'
})

export class LongPressDirective
{
	private touchTimeout: any;

	@Output()
	public longpress = new EventEmitter();

	public constructor()
	{}

	@HostListener('touchstart')
	public touchstart(): void
	{
		this.touchTimeout = setTimeout(() => {
			this.longpress.emit({});
		}, 800);
	}

	@HostListener('touchend')
	public touchend(): void
	{
		this.touchEnd();
	}

	@HostListener('touchcancel')
	public touchcancel(): void
	{
		this.touchEnd();
	}

	private touchEnd(): void
	{
		clearTimeout(this.touchTimeout);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/directives/long-press.directive.ts